import {appRouter} from '@netx/core-next/instance/router';

export const routeToAsset = (id: number) =>
	appRouter.navigate(`asset/${id}`, true);

export default routeToAsset;
